
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.052 3.628a.75.75 0 00-1.28-.53l-3.295 3.295-4.61-2.933a.75.75 0 00-.932.103l-6.493 6.492-2.264-1.887a.75.75 0 00-1.23.576v11.628c0 .414.336.75.75.75h18.604a.75.75 0 00.75-.75V3.628zm-1.5 6.27v-4.46l-2.44 2.441a.75.75 0 01-.933.103L12.57 5.049 6.02 11.6a.75.75 0 01-1.01.046l-1.561-1.3v4.628l1.994 1.663 6.493-6.493a.75.75 0 01.933-.102l4.609 2.933 3.075-3.076z"}})])
          )
        }
      }
    